<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" version="1.1" viewBox="0.00 0.00 640.00 640.00">
    <path
      d="
  M 162.98 199.35
  L 163.01 278.76
  Q 163.01 279.27 162.49 279.27
  L 142.73 279.23
  A 0.50 0.49 90.0 0 1 142.24 278.73
  L 142.22 199.53
  Q 142.22 199.04 141.73 199.09
  Q 131.50 200.15 125.60 192.13
  Q 120.37 185.03 120.34 175.74
  Q 120.30 165.20 120.33 154.64
  Q 120.35 145.91 121.82 141.75
  Q 124.68 133.68 132.25 128.26
  Q 134.62 126.57 137.13 126.53
  Q 151.93 126.34 166.75 126.38
  C 177.26 126.41 184.40 138.81 184.57 148.25
  Q 184.81 161.49 184.94 174.74
  C 185.06 186.39 177.28 201.35 163.50 198.91
  Q 162.98 198.82 162.98 199.35
  Z
  M 168.75 149.15
  A 2.39 2.39 0.0 0 0 166.36 146.76
  L 138.82 146.76
  A 2.39 2.39 0.0 0 0 136.43 149.15
  L 136.43 176.11
  A 2.39 2.39 0.0 0 0 138.82 178.50
  L 166.36 178.50
  A 2.39 2.39 0.0 0 0 168.75 176.11
  L 168.75 149.15
  Z"
    />
    <path
      d="
  M 312.92 199.06
  A 0.92 0.91 -85.7 0 0 311.87 199.97
  L 311.84 278.47
  A 0.81 0.81 0.0 0 1 311.03 279.28
  L 291.70 279.26
  A 0.81 0.81 0.0 0 1 290.89 278.45
  L 290.90 199.75
  A 0.74 0.74 0.0 0 0 290.05 199.02
  C 280.70 200.47 273.51 193.23 270.73 184.91
  Q 269.50 181.21 269.37 173.93
  Q 269.19 163.65 269.30 153.36
  Q 269.40 144.37 270.78 140.50
  C 272.74 135.01 277.67 129.01 283.50 127.04
  Q 285.43 126.39 288.84 126.38
  Q 303.29 126.36 317.75 126.39
  C 323.24 126.40 330.17 135.82 332.16 140.92
  Q 333.44 144.21 333.47 149.51
  Q 333.55 160.85 333.51 172.19
  Q 333.47 180.85 332.32 184.65
  C 329.79 193.01 322.11 200.45 312.92 199.06
  Z
  M 317.45 149.55
  A 2.32 2.32 0.0 0 0 315.13 147.23
  L 287.83 147.23
  A 2.32 2.32 0.0 0 0 285.51 149.55
  L 285.51 176.03
  A 2.32 2.32 0.0 0 0 287.83 178.35
  L 315.13 178.35
  A 2.32 2.32 0.0 0 0 317.45 176.03
  L 317.45 149.55
  Z"
    />
    <path
      d="
  M 431.93 199.54
  L 431.96 278.78
  Q 431.96 279.26 431.47 279.26
  L 411.49 279.25
  A 0.26 0.26 0.0 0 1 411.23 278.99
  L 411.19 199.78
  Q 411.19 199.25 410.66 199.27
  Q 396.99 199.73 391.74 187.21
  Q 389.21 181.18 389.20 174.49
  Q 389.18 165.62 389.29 156.73
  Q 389.43 144.59 391.21 139.98
  Q 394.51 131.47 403.46 127.43
  Q 405.95 126.31 409.37 126.32
  Q 421.60 126.36 433.73 126.41
  Q 438.52 126.43 441.08 127.50
  C 449.21 130.90 453.67 140.66 453.77 149.00
  Q 454.04 172.09 453.56 179.50
  Q 453.19 185.15 448.67 191.68
  Q 442.76 200.23 432.44 199.09
  Q 431.93 199.03 431.93 199.54
  Z
  M 437.75 149.18
  A 2.42 2.42 0.0 0 0 435.33 146.76
  L 407.83 146.76
  A 2.42 2.42 0.0 0 0 405.41 149.18
  L 405.41 176.08
  A 2.42 2.42 0.0 0 0 407.83 178.50
  L 435.33 178.50
  A 2.42 2.42 0.0 0 0 437.75 176.08
  L 437.75 149.18
  Z"
    />
    <path
      d="
  M 563.10 351.48
  A 0.69 0.68 89.6 0 0 562.42 350.80
  Q 431.35 350.91 302.53 350.83
  Q 302.45 350.83 290.97 351.09
  C 285.76 351.21 279.89 350.81 275.34 350.81
  Q 147.67 350.89 20.00 350.85
  C -4.04 350.85 -6.52 308.11 14.16 301.47
  Q 16.83 300.61 24.18 300.61
  Q 129.34 300.67 234.50 300.73
  Q 265.76 300.75 278.59 300.66
  C 280.72 300.64 285.88 300.15 289.48 300.39
  Q 292.74 300.61 294.04 300.61
  C 383.56 300.66 473.11 301.11 562.63 300.64
  A 0.48 0.48 0.0 0 0 563.11 300.16
  Q 563.09 291.05 563.10 281.88
  Q 563.11 278.09 564.37 275.91
  C 565.69 273.63 569.26 269.29 572.36 271.20
  Q 578.11 274.74 590.62 284.39
  C 592.99 286.22 597.02 288.27 599.96 290.42
  Q 616.73 302.75 633.42 315.19
  Q 637.78 318.44 638.85 320.92
  C 641.88 327.90 635.86 333.22 630.60 337.21
  C 625.57 341.02 620.65 345.55 615.95 349.05
  Q 594.66 364.89 573.31 380.65
  Q 572.42 381.31 570.40 381.20
  C 566.60 380.98 563.75 376.65 563.18 373.40
  Q 563.06 372.75 563.14 365.58
  Q 563.21 358.40 563.10 351.48
  Z"
    />
    <path
      d="
  M 294.08 366.88
  L 294.87 375.19
  Q 294.93 375.80 294.65 375.25
  C 293.71 373.46 294.04 369.68 294.14 366.89
  Q 294.14 366.87 294.13 366.87
  Q 294.13 366.87 294.13 366.87
  Q 294.08 366.87 294.08 366.88
  Z"
    />
    <path
      d="
  M 99.45 442.00
  C 109.53 440.73 117.35 448.52 119.47 458.04
  C 120.14 461.09 119.83 464.63 120.05 468.00
  C 120.28 471.75 119.85 476.29 120.30 481.00
  Q 120.90 487.11 119.90 494.22
  C 118.62 503.30 115.85 510.38 107.48 513.76
  Q 104.46 514.98 99.18 514.92
  Q 86.43 514.79 73.75 514.91
  C 63.83 515.01 56.35 503.05 56.13 494.37
  Q 55.48 468.66 56.25 461.00
  C 57.21 451.40 65.20 440.74 76.33 442.06
  A 1.29 1.29 0.0 0 0 77.77 440.78
  L 77.67 372.28
  Q 77.67 371.74 78.22 371.74
  L 97.41 371.87
  Q 98.69 371.88 98.69 373.16
  L 98.66 441.29
  Q 98.65 442.10 99.45 442.00
  Z
  M 104.2375 464.5655
  A 2.00 2.00 0.0 0 0 102.2445 462.5585
  L 74.5047 462.4617
  A 2.00 2.00 0.0 0 0 72.4977 464.4547
  L 72.4025 491.7345
  A 2.00 2.00 0.0 0 0 74.3955 493.7415
  L 102.1353 493.8383
  A 2.00 2.00 0.0 0 0 104.1423 491.8453
  L 104.2375 464.5655
  Z"
    />
    <path
      d="
  M 368.46 442.02
  C 378.72 440.66 386.51 448.83 388.54 458.41
  C 389.15 461.30 388.85 464.69 389.03 467.89
  C 389.25 471.76 388.86 476.53 389.31 481.37
  Q 389.88 487.61 388.83 494.70
  Q 387.60 503.00 384.74 507.19
  C 380.69 513.10 375.59 515.00 368.19 514.92
  Q 358.28 514.82 348.41 514.88
  Q 340.56 514.93 337.28 513.58
  C 327.87 509.69 325.09 498.88 325.01 489.64
  Q 324.91 478.65 325.03 467.67
  Q 325.11 460.52 326.23 456.98
  C 328.96 448.36 335.35 440.89 345.32 442.04
  A 1.25 1.25 0.0 0 0 346.71 440.80
  L 346.59 372.31
  Q 346.58 371.70 347.19 371.70
  L 366.12 371.87
  Q 367.61 371.89 367.61 373.37
  L 367.64 441.30
  A 0.73 0.72 86.2 0 0 368.46 442.02
  Z
  M 373.2171 464.6855
  A 2.12 2.12 0.0 0 0 371.1045 462.5581
  L 343.5847 462.4621
  A 2.12 2.12 0.0 0 0 341.4573 464.5747
  L 341.3629 491.6145
  A 2.12 2.12 0.0 0 0 343.4755 493.7419
  L 370.9953 493.8379
  A 2.12 2.12 0.0 0 0 373.1227 491.7253
  L 373.2171 464.6855
  Z"
    />
    <path
      d="
  M 510.07 441.92
  C 525.88 440.89 530.79 455.42 531.05 468.53
  Q 531.31 481.62 531.03 491.00
  C 530.68 502.66 524.83 514.86 511.19 514.84
  Q 497.21 514.81 483.24 514.85
  Q 478.90 514.86 474.29 510.46
  C 467.91 504.36 466.74 498.59 466.64 489.26
  Q 466.45 471.83 466.77 462.00
  Q 466.95 456.86 469.90 451.52
  Q 475.64 441.17 487.54 441.91
  A 0.77 0.77 0.0 0 0 488.33 441.35
  C 488.95 439.12 488.18 436.05 488.18 434.50
  Q 488.25 403.43 488.14 372.35
  A 0.65 0.65 0.0 0 1 488.79 371.70
  L 508.48 371.89
  A 0.68 0.68 0.0 0 1 509.15 372.57
  L 509.11 441.02
  Q 509.11 441.99 510.07 441.92
  Z
  M 514.7626 465.1579
  A 2.73 2.73 0.0 0 0 512.0374 462.4232
  L 485.5174 462.3769
  A 2.73 2.73 0.0 0 0 482.7827 465.1021
  L 482.7374 491.0421
  A 2.73 2.73 0.0 0 0 485.4626 493.7768
  L 511.9826 493.8231
  A 2.73 2.73 0.0 0 0 514.7173 491.0979
  L 514.7626 465.1579
  Z"
    />
  </svg>
</template>
